<template>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="!isInitError" id="contents1">
    <div class="com_w_title1">
      <h2 class="com_inner1 clearfix">《奨励制度/表彰制度&emsp;実績進捗表》</h2>
    </div>
    <div class="com_inner1 clearfix">
      <div class="parent">
        <div class="left-side">&nbsp;</div>
        <ul class="com_page_ancor1">
          <li>
            <a href="#anchor1"><span>奨励制度</span></a>
          </li>
          <li>
            <a href="#anchor2"><span>表彰制度</span></a>
          </li>
        </ul>
        <div class="right-side">
          <a
            v-if="jissekiFileName"
            href="#"
            class="com_s_button1"
            @click.prevent="downloadFile"
          >
            <span class="text">
              <span class="text__item">実績進捗表のダウンロードはこちら</span>
              <span class="text__item" aria-hidden="true">
                実績進捗表のダウンロードはこちら
              </span>
            </span>
          </a>
        </div>
      </div>
      <div class="com_data_title1">
        <div>
          <h2 class="title1">
            <span class="anchor1" id="anchor1"></span>奨励制度
          </h2>
          <a :href="shoreiLinkUrl" target="_blank" class="link1 com_link2 g">
            奨励制度について</a
          >
        </div>
        <div>
          <div class="select1">
            <div>
              <select
                name=""
                class="com_f_select1"
                v-model="targetSystem"
                v-on:change="onChangeTargetSystem"
              >
                <option
                  v-for="item in targetSystemList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.text }}
                </option>
              </select>
            </div>
            <div>
              <div class="com_f_sw_radio1">
                <input
                  type="radio"
                  id="targetYearPrev"
                  :value="IncentiveConstants.TARGET_YEAR_PREV"
                  v-model="targetYear"
                  v-on:change="onChangeTargetYear"
                />
                <label for="targetYearPrev">前年</label>
                <input
                  type="radio"
                  id="targetYearCurrent"
                  :value="IncentiveConstants.TARGET_YEAR_CURRENT"
                  v-model="targetYear"
                  v-on:change="onChangeTargetYear"
                />
                <label for="targetYearCurrent">今年</label>
              </div>
            </div>
          </div>
        </div>
        <div :class="{ 'hidden-element': !isTargetYearCurrent }">
          <p class="com_fs14">参考：当月時点奨励制度進捗状況</p>
          <table>
            <tbody>
              <tr class="row-height1">
                <th>累計増加額実績</th>
                <td>
                  <span
                    v-if="isGetJisseki && shoreiRuikeiZokagaku"
                    :class="{
                      negative: isNegativeComputed(shoreiRuikeiZokagaku),
                    }"
                  >
                    {{ formatCurrency(shoreiRuikeiZokagaku) }}
                  </span>
                </td>
              </tr>
              <tr class="row-height1">
                <th>奨励金進捗状況</th>
                <td>
                  <span
                    v-if="isGetJisseki && shoreiShinchokuJokyo"
                    :class="{
                      negative: isNegativeComputed(shoreiShinchokuJokyo),
                    }"
                  >
                    {{ formatCurrency(shoreiShinchokuJokyo) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <table class="com_inc_tabel1 a">
        <thead>
          <tr>
            <th colspan="2"></th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '1' }"
              class="col-month-s"
            >
              1月
            </th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '2' }"
              class="col-month-s"
            >
              2月
            </th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '3' }"
              class="col-month-s"
            >
              3月
            </th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '4' }"
              class="col-month-s"
            >
              4月
            </th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '5' }"
              class="col-month-s"
            >
              5月
            </th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '6' }"
              class="col-month-s"
            >
              6月
            </th>
            <th class="all1 col-shorei-total">上期合計</th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '7' }"
              class="col-month-s"
            >
              7月
            </th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '8' }"
              class="col-month-s"
            >
              8月
            </th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '9' }"
              class="col-month-s"
            >
              9月
            </th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '10' }"
              class="col-month-s"
            >
              10月
            </th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '11' }"
              class="col-month-s"
            >
              11月
            </th>
            <th
              :class="{ this1: shoreiList[0]?.hokokuMonth == '12' }"
              class="col-month-s"
            >
              12月
            </th>
            <th class="all1 col-total-s">下期合計</th>
            <th class="all1 col-total-s">当月累計</th>
            <th class="all1 col-total-s">年間合計</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(group, index) in getShoreiGroupedData" :key="index">
            <tr
              v-for="(item, rowIndex) in group"
              :key="rowIndex"
              :class="{
                bg1: isChangeBgColorShorei(item),
                bdb1: rowIndex === group.length - 1,
              }"
            >
              <th v-if="rowIndex == 0" :rowspan="group.length" class="vt1">
                {{ item.groupTitle }}
              </th>
              <th>{{ item.rowTitle }}</th>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '1' }">
                <span :class="{ minus1: isNegative(item.month01) }">
                  {{ item.month01 }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '2' }">
                <span :class="{ minus1: isNegative(item.month02) }">
                  {{ item.month02 }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '3' }">
                <span :class="{ minus1: isNegative(item.month03) }">
                  {{ item.month03 }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '4' }">
                <span :class="{ minus1: isNegative(item.month04) }">
                  {{ item.month04 }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '5' }">
                <span :class="{ minus1: isNegative(item.month05) }">
                  {{ item.month05 }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '6' }">
                <span :class="{ minus1: isNegative(item.month06) }">
                  {{ item.month06 }}
                </span>
              </td>
              <td class="all1">
                <span :class="{ minus1: isNegative(item.kamikiTotal) }">
                  {{ item.kamikiTotal }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '7' }">
                <span :class="{ minus1: isNegative(item.month07) }">
                  {{ item.month07 }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '8' }">
                <span :class="{ minus1: isNegative(item.month08) }">
                  {{ item.month08 }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '9' }">
                <span :class="{ minus1: isNegative(item.month09) }">
                  {{ item.month09 }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '10' }">
                <span :class="{ minus1: isNegative(item.month10) }">
                  {{ item.month10 }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '11' }">
                <span :class="{ minus1: isNegative(item.month11) }">
                  {{ item.month11 }}
                </span>
              </td>
              <td :class="{ this1: shoreiList[0]?.hokokuMonth == '12' }">
                <span :class="{ minus1: isNegative(item.month12) }">
                  {{ item.month12 }}
                </span>
              </td>
              <td class="all1">
                <span :class="{ minus1: isNegative(item.shimokiTotal) }">
                  {{ item.shimokiTotal }}
                </span>
              </td>
              <td class="all1">
                <span :class="{ minus1: isNegative(item.togetsuRuikei) }">
                  {{ item.togetsuRuikei }}
                </span>
              </td>
              <td class="all1">
                <span :class="{ minus1: isNegative(item.yearTotal) }">
                  {{ item.yearTotal }}
                </span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <p v-if="isShoreiDispUniqueKado" class="com_fs12 com_mgt10">
        ※累計ユニーク…集計期間中にご購入頂いたお客様数
      </p>
      <div class="com_inc_cnt1">
        <div>
          <h3>上半期</h3>
          <ShoreiChartComponent
            v-if="isGetJisseki"
            :labels="['1月', '2月', '3月', '4月', '5月', '6月']"
            :tonenChartData="shoreiKamikiUriageChart.tonenDataList"
            :zennenChartData="shoreiKamikiUriageChart.zennenDataList"
            :mokuhyoChartData="shoreiKamikiUriageChart.mokuhyoDataList"
            :ruikeiChartData="shoreiKamikiUriageChart.ruikeiDataList"
          />
        </div>
        <div>
          <h3>下半期</h3>
          <ShoreiChartComponent
            v-if="isGetJisseki"
            :labels="['7月', '8月', '9月', '10月', '11月', '12月']"
            :tonenChartData="shoreiShimokiUriageChart.tonenDataList"
            :zennenChartData="shoreiShimokiUriageChart.zennenDataList"
            :mokuhyoChartData="shoreiShimokiUriageChart.mokuhyoDataList"
            :ruikeiChartData="shoreiShimokiUriageChart.ruikeiDataList"
          />
        </div>
      </div>
      <div class="com_mgt35 separator-top-1px"></div>
      <div class="com_data_title1 com_mgt35">
        <div>
          <h2 class="title1">
            <span class="anchor1" id="anchor2"></span>表彰制度
          </h2>
          <a :href="hyoshoLinkUrl" target="_blank" class="link1 com_link2 g">
            表彰制度について</a
          >
        </div>
        <div>
          <p class="com_fs14">参考：当月時点表彰制度進捗状況</p>
          <table>
            <tbody>
              <tr class="row-height1">
                <th>売上累計増加額実績</th>
                <td>
                  <span
                    v-if="isGetJisseki && hyoshoRuikeiZokagaku"
                    :class="{
                      negative: isNegativeComputed(hyoshoRuikeiZokagaku),
                    }"
                  >
                    {{ formatCurrency(hyoshoRuikeiZokagaku) }}
                  </span>
                </td>
              </tr>
              <tr v-if="isHyoshoDispUniqueKado" class="row-height1">
                <th>累計ユニーク稼働ID実績</th>
                <td>
                  <span
                    v-if="isGetJisseki && hyoshoRuikeiKadoId"
                    :class="{
                      negative: isNegativeComputed(hyoshoRuikeiKadoId),
                    }"
                  >
                    {{ hyoshoRuikeiKadoId + "ID" }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <table class="com_inc_tabel1 b">
        <thead>
          <tr>
            <th colspan="2"></th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '8' }"
              class="col-month-h"
            >
              8月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '9' }"
              class="col-month-h"
            >
              9月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '10' }"
              class="col-month-h"
            >
              10月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '11' }"
              class="col-month-h"
            >
              11月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '12' }"
              class="col-month-h"
            >
              12月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '1' }"
              class="col-month-h"
            >
              1月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '2' }"
              class="col-month-h"
            >
              2月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '3' }"
              class="col-month-h"
            >
              3月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '4' }"
              class="col-month-h"
            >
              4月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '5' }"
              class="col-month-h"
            >
              5月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '6' }"
              class="col-month-h"
            >
              6月
            </th>
            <th
              :class="{ this1: hyoshoList[0]?.hokokuMonth == '7' }"
              class="col-month-h"
            >
              7月
            </th>
            <th class="all1 col-total-h">当月累計</th>
            <th class="all1 col-total-h">年間合計</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(group, index) in getHyoshoGroupedData" :key="index">
            <tr
              v-for="(item, rowIndex) in group"
              :key="rowIndex"
              :class="{
                bg1: isChangeBgColorHyosho(item),
                bdb1: rowIndex === group.length - 1,
              }"
            >
              <th v-if="rowIndex == 0" :rowspan="group.length" class="vt1">
                {{ item.groupTitle }}
              </th>
              <th>{{ item.rowTitle }}</th>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '8' }">
                <span :class="{ minus1: isNegative(item.month01) }">
                  {{ item.month01 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '9' }">
                <span :class="{ minus1: isNegative(item.month02) }">
                  {{ item.month02 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '10' }">
                <span :class="{ minus1: isNegative(item.month03) }">
                  {{ item.month03 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '11' }">
                <span :class="{ minus1: isNegative(item.month04) }">
                  {{ item.month04 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '12' }">
                <span :class="{ minus1: isNegative(item.month05) }">
                  {{ item.month05 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '1' }">
                <span :class="{ minus1: isNegative(item.month06) }">
                  {{ item.month06 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '2' }">
                <span :class="{ minus1: isNegative(item.month07) }">
                  {{ item.month07 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '3' }">
                <span :class="{ minus1: isNegative(item.month08) }">
                  {{ item.month08 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '4' }">
                <span :class="{ minus1: isNegative(item.month09) }">
                  {{ item.month09 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '5' }">
                <span :class="{ minus1: isNegative(item.month10) }">
                  {{ item.month10 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '6' }">
                <span :class="{ minus1: isNegative(item.month11) }">
                  {{ item.month11 }}
                </span>
              </td>
              <td :class="{ this1: hyoshoList[0]?.hokokuMonth == '7' }">
                <span :class="{ minus1: isNegative(item.month12) }">
                  {{ item.month12 }}
                </span>
              </td>
              <td class="all1">
                <span :class="{ minus1: isNegative(item.togetsuRuikei) }">
                  {{ item.togetsuRuikei }}
                </span>
              </td>
              <td class="all1">
                <span :class="{ minus1: isNegative(item.yearTotal) }">
                  {{ item.yearTotal }}
                </span>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
      <p v-if="isHyoshoDispUniqueKado" class="com_fs12 com_mgt10">
        ※累計ユニーク…集計期間中にご購入頂いたお客様数
      </p>
      <div class="com_inc_cnt2">
        <div>
          <h3>売上累計増加金額</h3>
          <HyoshoChartComponent
            v-if="isGetJisseki"
            :tonenChartData="hyoshoUriageChart.tonenDataList"
            :zennenChartData="hyoshoUriageChart.zennenDataList"
            :ruikeiChartData="hyoshoUriageChart.ruikeiDataList"
          />
        </div>
        <div v-if="isHyoshoDispUniqueKado">
          <h3>累計ユニーク稼働ID増加数</h3>
          <HyoshoChartComponent
            v-if="isGetJisseki"
            :tonenChartData="hyoshoKadoIdChart.tonenDataList"
            :zennenChartData="hyoshoKadoIdChart.zennenDataList"
            :ruikeiChartData="hyoshoKadoIdChart.ruikeiDataList"
          />
        </div>
      </div>
    </div>
  </div>
  <!-- フッタ -->
  <FooterComponent />
  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import apiClient from "@/util/apiClient";
import apiAuthClient from "@/util/apiClientAuth";
import {
  outputDebugLogs,
  formatMessage,
  getTargetDate,
  isTokenAlive,
} from "@/Common";
import { AxiosError } from "axios";
import messages from "@/assets/messages.json";
import ShoreiChartComponent from "../layout/ShoreiChartComponent.vue";
import HyoshoChartComponent from "../layout/HyoshoChartComponent.vue";
import { AppConstants } from "@/constants/AppConstants";
import apiDownloadClient from "@/util/apiClientDownload";
import BackToTop from "../controls/BackToTop.vue";
import { useProcessingStore } from "../../store/useProcessingStore";
import FooterComponent from "../layout/FooterComponent.vue";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

// SelectItem のinterface
interface SelectItem {
  value: string;
  text: string;
}

// 奨励制度の実績データのinterface
interface ShoreiData {
  groupNo: string; // グループ番号
  groupTitle: string; // グループタイトル
  rowNo: string; // 行番号
  rowTitle: string; // 行タイトル
  month01: string; // 単月01
  month02: string; // 単月02
  month03: string; // 単月03
  month04: string; // 単月04
  month05: string; // 単月05
  month06: string; // 単月06
  month07: string; // 単月07
  month08: string; // 単月08
  month09: string; // 単月09
  month10: string; // 単月10
  month11: string; // 単月11
  month12: string; // 単月12
  kamikiTotal: string; // 上期合計
  shimokiTotal: string; // 下期合計
  togetsuRuikei: string; // 当月累計
  yearTotal: string; // 年間合計
  ruikeiZokagaku: string; // 売上累計増加額実績
  shinchokuJokyo: string; // 報奨金進捗状況
  jissekiType: string; // 実績種別
  hokokuYear: string; // 報告年
  hokokuMonth: string; // 報告月
  groupNoKanriId: string; // グループ番号の管理ID
}

// 表彰制度の実績データのinterface
interface HyoshoData {
  groupNo: string; // グループ番号
  groupTitle: string; // グループタイトル
  rowNo: string; // 行番号
  rowTitle: string; // 行タイトル
  month01: string; // 単月01
  month02: string; // 単月02
  month03: string; // 単月03
  month04: string; // 単月04
  month05: string; // 単月05
  month06: string; // 単月06
  month07: string; // 単月07
  month08: string; // 単月08
  month09: string; // 単月09
  month10: string; // 単月10
  month11: string; // 単月11
  month12: string; // 単月12
  togetsuRuikei: string; // 当月累計
  yearTotal: string; // 年間合計
  ruikeiZokagaku: string; // 売上累計増加額実績
  ruikeiKadoId: string; // 累計ユニーク稼動ID実績
  jissekiType: string; // 実績種別
  hokokuYear: string; // 報告年
  hokokuMonth: string; // 報告月
  groupNoKanriId: string; // グループ番号の管理ID
}

// 奨励制度のグラフデータのinterface
interface ShoreiChartData {
  tonenDataList: number[]; // 当年データ
  zennenDataList: number[]; // 前年データ
  mokuhyoDataList: number[]; // 目標データ
  ruikeiDataList: number[]; // 累計データ
}

// 表彰制度のグラフデータのinterface
interface HyoshoChartData {
  tonenDataList: number[]; // 当年データ
  zennenDataList: number[]; // 前年データ
  ruikeiDataList: number[]; // 累計データ
}

class IncentiveConstants {
  // API-URL
  static readonly API_URL_CHECK_DISPLAY = "/api/Auth/checkIncentiveDisplay";
  static readonly API_URL_INITIAL_DISPLAY =
    "/api/Incentive/getInitialDisplayData";
  static readonly API_URL_GET_INCENTIVE = "/api/Incentive/getIncentiveJisseki";
  static readonly API_URL_GET_INCENTIVE_SHOREI =
    "/api/Incentive/getIncentiveJisseki/shorei";
  static readonly API_URL_DOWNLOAD = "/api/download/incentive";

  // 対象年
  static readonly TARGET_YEAR_CURRENT = "0"; // 今年
  static readonly TARGET_YEAR_PREV = "1"; // 前年

  // 表彰制度のグループの管理ID
  static readonly HYOSHO_GROUP_KANRI_ID_URI = "001"; // 売上
  static readonly HYOSHO_GROUP_KANRI_ID_KADO = "002"; // 稼働ID

  // 奨励制度のグループの管理ID
  static readonly SHOREI_GROUP_KANRI_ID_URI = "001"; // 売上
  static readonly SHOREI_GROUP_KANRI_ID_KADO = "002"; // 稼働ID
  static readonly SHOREI_GROUP_KANRI_ID_KOKYAKU_TANKA = "003"; // 顧客単価
}

export default defineComponent({
  name: "IncentiveComponent",
  components: {
    ShoreiChartComponent,
    HyoshoChartComponent,
    BackToTop,
    FooterComponent,
    LoadingOverlay,
  },
  computed: {
    isNegativeComputed(): (target: string | null) => boolean {
      return (target: string | null): boolean => {
        if (target) {
          // 負の数（負のパーセンテージも含む）を判定
          const regex = /^-\d{1,3}(,\d{3})*(\.\d+)?%?$/;
          return regex.test(target.trim());
        }
        return false;
      };
    },
  },
  setup() {
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const isGetJisseki = ref(false); // 実績データ取得フラグ
    const targetSystemList = ref<SelectItem[]>([]); // 対象システムのリスト
    const targetSystem = ref("");
    const targetYear = ref("");
    const shoreiLinkUrl = ref("");
    const hyoshoLinkUrl = ref("");
    const jissekiFileName = ref("");
    const systemKbn = ref<string | null>("");
    const agCode = ref<string | null>("");
    const daihyoCode = ref<string | null>("");
    const userId = ref<string | null>("");
    const token = ref<string | null>("");
    const processingStore = useProcessingStore();
    const isLoading = ref(false);

    // 奨励制度
    const shoreiRuikeiZokagaku = ref(""); // 売上累計増加額実績
    const shoreiShinchokuJokyo = ref(""); // 報奨金進捗状況
    const shoreiList = ref<ShoreiData[]>([]); // 実績データリスト
    const shoreiKamikiUriageChart = ref<ShoreiChartData>({
      tonenDataList: [], // 当年データ
      zennenDataList: [], // 前年データ
      mokuhyoDataList: [], // 目標データ
      ruikeiDataList: [], // 累計データ
    });
    const shoreiShimokiUriageChart = ref<ShoreiChartData>({
      tonenDataList: [], // 当年データ
      zennenDataList: [], // 前年データ
      mokuhyoDataList: [], // 目標データ
      ruikeiDataList: [], // 累計データ
    });
    const isShoreiDispUniqueKado = ref(true); // ユニーク稼働IDの表示フラグ

    // 表彰制度
    const hyoshoRuikeiZokagaku = ref(""); // 売上累計増加額実績
    const hyoshoRuikeiKadoId = ref(""); // 累計ユニーク稼働ID増加数
    const hyoshoList = ref<HyoshoData[]>([]); //実績データリスト
    const hyoshoUriageChart = ref<HyoshoChartData>({
      tonenDataList: [], // 当年データ
      zennenDataList: [], // 前年データ
      ruikeiDataList: [], // 累計データ
    });
    const hyoshoKadoIdChart = ref<HyoshoChartData>({
      tonenDataList: [], // 当年データ
      zennenDataList: [], // 前年データ
      ruikeiDataList: [], // 累計データ
    });
    const isHyoshoDispUniqueKado = ref(true); // ユニーク稼働IDの表示フラグ

    // 初期処理
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;
      outputDebugLogs("IncentiveComponent Start");
      try {
        // ローカルストレージの情報取得
        systemKbn.value = localStorage.getItem(
          AppConstants.INCENTIVE_SYSTEM_KBN_SESSION_NAME
        );
        agCode.value = localStorage.getItem(
          AppConstants.INCENTIVE_AG_CODE_SESSION_NAME
        );
        daihyoCode.value = localStorage.getItem(
          AppConstants.INCENTIVE_DAIHYO_CODE_SESSION_NAME
        );
        userId.value = localStorage.getItem(
          AppConstants.INCENTIVE_USER_ID_SESSION_NAME
        );
        token.value = localStorage.getItem(
          AppConstants.INCENTIVE_TOKEN_SESSION_NAME
        );

        // ローカルストレージの情報削除
        localStorage.removeItem(AppConstants.INCENTIVE_SYSTEM_KBN_SESSION_NAME);
        localStorage.removeItem(AppConstants.INCENTIVE_AG_CODE_SESSION_NAME);
        localStorage.removeItem(
          AppConstants.INCENTIVE_DAIHYO_CODE_SESSION_NAME
        );
        localStorage.removeItem(AppConstants.INCENTIVE_USER_ID_SESSION_NAME);
        localStorage.removeItem(AppConstants.INCENTIVE_TOKEN_SESSION_NAME);

        // 画面表示チェック
        if (!(await checkDisplay())) {
          return;
        }

        outputDebugLogs("画面表示チェック終了");

        // 画面初期データ取得
        if (!(await getInitialDisplayData())) {
          return;
        }

        outputDebugLogs("画面初期データ取得終了");

        // インセンティブ実績データ取得
        if (!(await getIncentiveJisseki())) {
          return;
        }

        outputDebugLogs("インセンティブ実績データ取得終了");

        isInitError.value = false;
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    });

    /**
     * 画面表示チェック
     */
    const checkDisplay = async (): Promise<boolean> => {
      try {
        // 画面表示チェックAPIを実行
        const response = await apiClient.post(
          IncentiveConstants.API_URL_CHECK_DISPLAY,
          {
            systemKbn: systemKbn.value,
            agCode: agCode.value,
            userId: userId.value,
            daihyoCode: daihyoCode.value,
            token: token.value,
          }
        );

        // トークン有効性チェック
        let tokenAlibe = await isTokenAlive();

        // ローカルストレージのトークンを取得
        // const localToken = localStorage.getItem(
        //   AppConstants.TOKEN_SESSION_NAME
        // );

        if (!tokenAlibe) {
          // トークンが無効な場合
          // レスポンスのトークンをローカルストレージにセット
          outputDebugLogs("ローカルストレージにトークンを設定");
          localStorage.setItem(
            AppConstants.TOKEN_SESSION_NAME,
            response.data.token
          );
        }

        return true;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 401:
              // 認証エラー
              alert(formatMessage(messages.ERR_USER006));
              throw error;
            default:
              // その他のエラー
              throw error;
          }
        } else {
          throw error;
        }
      }
    };

    /**
     * 画面初期データ取得
     */
    const getInitialDisplayData = async (): Promise<boolean> => {
      try {
        // 画面初期データ取得APIを実行
        const response = await apiAuthClient.post(
          IncentiveConstants.API_URL_INITIAL_DISPLAY,
          {
            systemKbn: systemKbn.value,
            agCode: agCode.value,
            userId: userId.value,
            daihyoCode: daihyoCode.value,
            targetDate: getTargetDate(""),
          }
        );

        targetSystemList.value = response.data.targetSystemList;
        shoreiLinkUrl.value = response.data.shoreiLinkUrl;
        hyoshoLinkUrl.value = response.data.hyoshoLinkUrl;
        jissekiFileName.value = response.data.jissekiFileName;
        // ユニーク稼働ID表示制御
        // 管理マスタ値が"0"の場合のみ非表示、未設定含むその他は表示
        isShoreiDispUniqueKado.value =
          response.data.dispUniqueKadoShorei !== "0";
        isHyoshoDispUniqueKado.value =
          response.data.dispUniqueKadoHyosho !== "0";

        targetSystem.value = targetSystemList.value[0].value; // 全体を選択
        targetYear.value = IncentiveConstants.TARGET_YEAR_CURRENT; // 今年を選択
        return true;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        throw error;
      }
    };

    /**
     * インセンティブ実績データ取得
     */
    const getIncentiveJisseki = async (): Promise<boolean> => {
      // 実績データ取得フラグOFF
      isGetJisseki.value = false;

      try {
        // インセンティブ実績データ取得APIを実行
        const response = await apiAuthClient.post(
          IncentiveConstants.API_URL_GET_INCENTIVE,
          {
            systemKbn: systemKbn.value,
            agCode: agCode.value,
            userId: userId.value,
            daihyoCode: daihyoCode.value,
            targetDate: getTargetDate(""),
            targetSystem: targetSystem.value,
            targetYear: targetYear.value,
          }
        );

        shoreiRuikeiZokagaku.value = response.data.shoreiRuikeiZokagaku;
        shoreiShinchokuJokyo.value = response.data.shoreiShinchokuJokyo;
        shoreiList.value = response.data.shoreiList;
        hyoshoRuikeiZokagaku.value = response.data.hyoshoRuikeiZokagaku;
        hyoshoRuikeiKadoId.value = response.data.hyoshoRuikeiKadoId;
        hyoshoList.value = response.data.hyoshoList;
        shoreiKamikiUriageChart.value = response.data.shoreiKamikiUriageChart;
        shoreiShimokiUriageChart.value = response.data.shoreiShimokiUriageChart;
        hyoshoUriageChart.value = response.data.hyoshoUriageChart;
        hyoshoKadoIdChart.value = response.data.hyoshoKadoIdChart;

        // 実績データ取得フラグON
        isGetJisseki.value = true;
        return true;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(formatMessage(messages.ERR_SYS999));
        throw error;
      }
    };

    /**
     * インセンティブ実績データ取得（奨励制度のみ）
     */
    const getIncentiveJissekiForShorei = async (): Promise<boolean> => {
      // 実績データ取得フラグOFF
      isGetJisseki.value = false;

      try {
        // インセンティブ実績データ取得（奨励制度のみ）APIを実行
        const response = await apiAuthClient.post(
          IncentiveConstants.API_URL_GET_INCENTIVE_SHOREI,
          {
            systemKbn: systemKbn.value,
            agCode: agCode.value,
            userId: userId.value,
            daihyoCode: daihyoCode.value,
            targetDate: getTargetDate(""),
            targetSystem: targetSystem.value,
            targetYear: targetYear.value,
          }
        );

        shoreiRuikeiZokagaku.value = response.data.shoreiRuikeiZokagaku;
        shoreiShinchokuJokyo.value = response.data.shoreiShinchokuJokyo;
        shoreiList.value = response.data.shoreiList;
        shoreiKamikiUriageChart.value = response.data.shoreiKamikiUriageChart;
        shoreiShimokiUriageChart.value = response.data.shoreiShimokiUriageChart;

        // 実績データ取得フラグON
        isGetJisseki.value = true;
        return true;
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        throw error;
      }
    };

    /**
     * 奨励制度の実績データをグループNoでグループ化した配列を返却します。
     */
    const getShoreiGroupedData = computed((): ShoreiData[][] => {
      return shoreiList.value.reduce(
        (groups: ShoreiData[][], item: ShoreiData) => {
          if (
            !isShoreiDispUniqueKado.value &&
            item.groupNoKanriId ===
              IncentiveConstants.SHOREI_GROUP_KANRI_ID_KADO
          ) {
            // ユニーク稼働IDの表示フラグがOFFの場合、奨励制度の稼働IDグループは除外する
            return groups;
          }

          const group = groups.find((g) => g[0]?.groupNo === item.groupNo);
          if (group) {
            group.push(item);
          } else {
            groups.push([item]);
          }
          return groups;
        },
        []
      );
    });

    /**
     * 表彰制度の実績データをグループNoでグループ化した配列を返却します。
     */
    const getHyoshoGroupedData = computed((): HyoshoData[][] => {
      return hyoshoList.value.reduce(
        (groups: HyoshoData[][], item: HyoshoData) => {
          if (
            !isHyoshoDispUniqueKado.value &&
            item.groupNoKanriId ===
              IncentiveConstants.HYOSHO_GROUP_KANRI_ID_KADO
          ) {
            // ユニーク稼働IDの表示フラグがOFFの場合、表彰制度の稼働IDグループは除外する
            return groups;
          }

          const group = groups.find((g) => g[0]?.groupNo === item.groupNo);
          if (group) {
            group.push(item);
          } else {
            groups.push([item]);
          }
          return groups;
        },
        []
      );
    });

    /**
     * 対象システム変更時
     */
    const onChangeTargetSystem = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // インセンティブ実績データ取得（奨励制度のみ）
        await getIncentiveJissekiForShorei();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 対象年変更時
     */
    const onChangeTargetYear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // インセンティブ実績データ取得（奨励制度のみ）
        await getIncentiveJissekiForShorei();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 奨励制度 trタグの背景色変更判定
     * @param item
     */
    const isChangeBgColorShorei = (item: ShoreiData): boolean => {
      // 売上前年増加額（単月）
      // 売上前年比
      // 売上前年増加額（単月）
      // 売上前年比
      if (
        item.jissekiType == "03" ||
        item.jissekiType == "04" ||
        item.jissekiType == "11" ||
        item.jissekiType == "14"
      ) {
        return true;
      }
      return false;
    };

    /**
     * 表彰制度 trタグの背景色変更判定
     * @param item
     */
    const isChangeBgColorHyosho = (item: HyoshoData): boolean => {
      // 売上前年比
      // 稼動ID前年差（単月）
      if (item.jissekiType == "04" || item.jissekiType == "09") {
        return true;
      }
      return false;
    };

    /**
     * 数値がマイナス値か判定します。
     * @param target
     */
    const isNegative = (target: string | null): boolean => {
      if (target) {
        // 負の数（負のパーセンテージも含む）を判定
        const regex = /^-\d{1,3}(,\d{3})*(\.\d+)?%?$/;
        return regex.test(target.trim());
      }
      return false;
    };

    /**
     * ファイルダウンロード
     */
    const downloadFile = async () => {
      // 何か処理中の場合は処理しない
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // ファイルダウンロードAPI
        const response = await apiDownloadClient.post(
          IncentiveConstants.API_URL_DOWNLOAD,
          {
            systemKbn: systemKbn.value,
            agCode: agCode.value,
            userId: userId.value,
            daihyoCode: daihyoCode.value,
            fileName: jissekiFileName.value,
            screenName: "インセンティブ画面",
          }
        );

        // Content-Dispositionヘッダーからファイル名を取得
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "downloaded_file";
        if (contentDisposition) {
          const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
          if (match && match[1]) {
            fileName = decodeURIComponent(match[1]);
          }
        }

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } catch (error) {
        // ダウンロードAPIエラー
        outputDebugLogs("Error downloading files: " + error);
        alert(formatMessage(messages.ERR_SYS003, "ファイルダウンロード"));
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    };

    /**
     * 対象年が今年か判定します。
     */
    const isTargetYearCurrent = computed((): boolean => {
      return targetYear.value == IncentiveConstants.TARGET_YEAR_CURRENT;
    });

    /**
     * 数値を通貨フォーマットに変換します。
     * @param value
     */
    const formatCurrency = (value: string): string => {
      // カンマを除去し、数値に変換
      const numberValue = parseFloat(value.replace(/,/g, ""));
      // 数値としてフォーマット
      if (isNaN(numberValue)) {
        return "¥0"; // 数値変換に失敗した場合は¥0とする
      }
      return numberValue < 0
        ? `-¥${Math.abs(numberValue).toLocaleString()}`
        : `¥${numberValue.toLocaleString()}`;
    };

    return {
      shoreiRuikeiZokagaku,
      shoreiShinchokuJokyo,
      shoreiList,
      hyoshoRuikeiZokagaku,
      hyoshoRuikeiKadoId,
      hyoshoList,
      getShoreiGroupedData,
      getHyoshoGroupedData,
      shoreiKamikiUriageChart,
      shoreiShimokiUriageChart,
      hyoshoUriageChart,
      hyoshoKadoIdChart,
      isInitError,
      isGetJisseki,
      targetSystemList,
      targetSystem,
      targetYear,
      onChangeTargetSystem,
      onChangeTargetYear,
      isChangeBgColorShorei,
      isChangeBgColorHyosho,
      isNegative,
      shoreiLinkUrl,
      hyoshoLinkUrl,
      IncentiveConstants,
      downloadFile,
      jissekiFileName,
      isTargetYearCurrent,
      formatCurrency,
      isLoading,
      isShoreiDispUniqueKado,
      isHyoshoDispUniqueKado,
    };
  },
});
</script>

<style scoped>
/*
  個別CSS
*/
.col-month-s {
  width: 68px;
}
.col-total-s {
  width: 74px;
}
.col-month-h {
  width: 73px;
}
.col-total-h {
  width: 81px;
}
.row-height1 {
  height: 33px;
}
.parent {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left-side {
  flex: 1;
}
.right-side {
  flex: 1;
  text-align: right;
}
.negative {
  color: red;
}
.hidden-element {
  visibility: hidden;
}
.separator-top-1px {
  border-top: 1px solid #999;
}
/*
  共通CSSカスタマイズ
*/
.com_inc_cnt2 {
  width: 1090px;
  max-width: none;
}
.com_s_button1 {
  width: auto;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
